export const sideNavigationWidthExpanded = '237px';
export const sideNavigationWidthShrunk = '75px';